import { useTranslation } from 'react-i18next';

export class ItemHelper {
  static getName(item, lang) {
    return item?.names?.[lang] || item?.name;
  }

  static getDescription(item, lang) {
    return item?.descriptions?.[lang]?.join('<br/>') || item?.description?.join('<br/>');
  }

  static getShortDescription(item, lang) {
    return item?.shortDescriptions?.[lang]?.join('<br/>') || item?.shortDescription?.join('<br/>');
  }

  static getLongDescription(item) {
    return item?.longDescription?.join('<br/>');
  }
  
  static getTag(item, lang, separator = '<br/>') {
    return item?.tags?.[lang]?.join(separator) || item?.tag?.join(separator);
  }

  static getPeriodDesc(item, lang) {
    return item?.periodDescs?.[lang] || item?.periodDesc;
  }

  static getVenue(itemDetail, lang) {
    return itemDetail?.venues?.[lang] || itemDetail?.venue;
  }

  static getRedeemDesc(itemDetail, i18n, lang) {
    return itemDetail?.redeemDesc || i18n.t(itemDetail?.redeemDescKey?.toLowerCase() ?? 'redeem_coupon_error_general').toString();
  }

  static openLink(item, window) {
    const uri = item?.targetURI;
    if (uri) {
      const internalProtocol = 'internal://';
      if (uri.startsWith(internalProtocol)) {
        // For routing in React
        window.location.href = uri.substring(internalProtocol.length);  // For internal routes
      } else {
        window.location.href = uri;
      }
    }
  }

  static convertCodeToCouponCriteria(code) {
    const criteria = { couponType: '', categoryCode: '', hotDeals: undefined };
    return code.split('&').reduce((previous, current) => {
      if (current.includes('couponType=')) {
        previous.couponType = current.split('couponType=')[1];
      } else if (current.includes('categoryCode=')) {
        previous.categoryCode = current.split('categoryCode=')[1];
      } else if (current.includes('hotDeals=')) {
        previous.hotDeals = current.split('hotDeals=')[1].toLowerCase() === 'true';
      }
      return previous;
    }, criteria);
  }
}

// In React components, you can use the useTranslation hook for localization like this:

export function YourComponent() {
  const { t } = useTranslation();

  const item = { /* your item data */ };
  const lang = 'en';  // or use dynamic language logic

  const description = ItemHelper.getDescription(item, lang);

  return (
    <div>
      <p>{description}</p>
    </div>
  );
}
